import { DEFAULT_PRESET_ID_FOR_ALL_DATASETS, DATA_RANGE } from '@awp/constants';

export const isDeferOnlyPreset = (preset) => {
  if (!preset) return false;
  if (preset.value === DEFAULT_PRESET_ID_FOR_ALL_DATASETS) return true;
  if (!preset || !Array.isArray(preset.DataGraphs)) {
    return false;
  }

  // Flatten all PersistentGraphFilters across all DataGraphs
  const allFilters = preset.DataGraphs.flatMap((graph) =>
    Array.isArray(graph.PersistentGraphFilters) ? graph.PersistentGraphFilters : [],
  );

  // If there are no filters, return false
  if (allFilters.length === 0) {
    return false;
  }

  // Return true only if ALL filters have WeatherStationId === null
  return allFilters.every((filter) => filter.WeatherStationId === null);
};

export const getMaxDayLabel = (maxDays) => {
  const _maxDays = maxDays ? maxDays : DATA_RANGE.MINIMUM;
  if (_maxDays > DATA_RANGE.MAXIMUM) return ` (max ${_maxDays} days)`;
  return '';
};
